import { renderMenuIcon } from '../utils/menuIcons';

/**
 * Converts the server menu (GET /api/access/me -> menu) into the shape Sidebar.jsx renders:
 *   [{ label, submenuItems: [{ label, link, icon, submenu, submenuItems }] }]
 *
 * Modules and pages come from the Operations_Module / Operations_Page tables and are already
 * filtered by the user's VIEW permissions (union of all Entra roles) on the server.
 * The old hardcoded ALL_MENUS / MENU_ORDER were removed with the move to Access Control.
 */
const toMenuItem = page => {
  const children = (page.children || []).map(toMenuItem);
  return {
    label: page.name,
    link: page.route || '#',
    icon: renderMenuIcon(page.icon),
    showSubRoute: false,
    submenu: children.length > 0,
    submenuItems: children.length > 0 ? children : undefined,
  };
};

export const buildSidebarData = menu =>
  (menu || []).map(module => ({
    label: module.name,
    submenuOpen: true,
    showSubRoute: false,
    submenuHdr: module.name,
    submenuItems: (module.pages || []).map(toMenuItem),
  }));
